import { Sentry, isSentryEnabled } from '@/configs/sentry.config';

/**
 * The admin panel's logger. Root CLAUDE.md §10 bans `console.log` in committed code; this is
 * the sanctioned alternative. Breadcrumbs attach to whatever error is reported next, which is
 * usually the only way to reconstruct what an admin was doing when a page broke.
 */
export const logBreadcrumb = (message: string, data?: Record<string, unknown>): void => {
  if (isSentryEnabled()) {
    Sentry.addBreadcrumb({ message, data, level: 'info' });
  }

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.info(`[shoutt] ${message}`, data ?? '');
  }
};

/** Reports a caught error that the UI recovered from. */
export const recordHandledError = (error: unknown, context?: Record<string, unknown>): void => {
  const normalised = error instanceof Error ? error : new Error(String(error));

  if (isSentryEnabled()) {
    // Context goes on a scope local to this event — setting it globally would make a one-off
    // detail stick to every later report.
    Sentry.withScope((scope) => {
      if (context) scope.setContext('detail', context);
      Sentry.captureException(normalised);
    });
  }

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.error(`[shoutt] ${normalised.message}`, context ?? '', normalised);
  }
};
